import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { SearchResults } from '@models/SearchResults'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { queryKey as projectenQueryKey } from '../../projecten/hooks/useProjectenSearch'
import { queryKey as projectQueryKey } from '../hooks/useProject'
import { updateMyList } from '../services/updateMyList'
import type { HoofdleidingProject } from '../types/HoofdleidingProject'

export { useUpdateMyList }

const useUpdateMyList = () => {
  const { errorAlert } = useAlerts()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateMyList,
    onSuccess: (data, variables) => {
      queryClient.setQueryData(
        [projectQueryKey, variables.aanvraagID],
        (old) => {
          if (!old) return

          return {
            ...old,
            myList: data.projecten.includes(variables.aanvraagID),
          }
        },
      )

      queryClient.setQueriesData({ queryKey: [projectenQueryKey] }, (old) => ({
        ...(old as SearchResults<HoofdleidingProject>),
        items: (old as SearchResults<HoofdleidingProject>).items.map(
          (item) => ({
            ...item,
            myList: data.projecten.includes(item.aanvraagID),
          }),
        ),
      }))
    },
    onError: (error: any) => {
      errorAlert('Fout bij aanpassen mijn lijst', error)
    },
  })
}
